import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ImportSource from '../../entities/importSource';
export function deleteImportSource(importSource: ImportSource, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = importSource.id;}
const _work = workingSet();




importSource.status = 'D';
importSource.addedOn = newHRTimestamp();
importSource.addedBy = getCurrentUserId();
importSource.importSource = targetImportSource;
importSource.importId = mergeId;
store.dispatch(Actions.ImportSourceActions.removeImportSourceQueue(importSource));
}


